import { cn } from "@/lib/utils";

export function RichText({ html, className }: { html: string; className?: string }) {
  if (!/<[a-z][\s\S]*>/i.test(html)) {
    return <p className={className}>{html}</p>;
  }

  return (
    <div
      className={cn("rich-content", className)}
      // Site content is sanitized by the API before it is stored.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
